import React, { useState } from 'react'
import OpcionesBoton from './OpcionesBoton';
import SubirImagenesContainer from '../../../SubirImagenes';
import { MDBCol } from 'mdbreact';
import { Image2 } from 'react-iconly';

const OpcionesCarousel = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [registro, setRegistro] = useState('')
    const [modal, setModal] = useState()

    const [urlImg, setUrlImg] = useState(styles?.urlImg)
    const [urlImg2, setUrlImg2] = useState(styles?.urlImg2)
    const [urlImg3, setUrlImg3] = useState(styles?.urlImg3)

    const modificarModal = (data) => {
        setModal(!modal)
        setRegistro(data)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: registro })
        setModal(false)
        if (registro == 'urlImg') return setUrlImg(img.path);
        if (registro == 'urlImg2') return setUrlImg2(img.path);
        if (registro == 'urlImg3') return setUrlImg3(img.path);
    }

    return (
        <>
            <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'style1' })}>
                <input type="checkbox" className="custom-control-input" id="estilo1" defaultChecked={styles?.style1} />
                <label className="custom-control-label" htmlFor="estilo1">Estilo 1</label>
            </div>
            <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'style2' })}>
                <input type="checkbox" className="custom-control-input" id="estilo2" defaultChecked={styles?.style2} />
                <label className="custom-control-label" htmlFor="estilo2">Estilo 2</label>
            </div>
            <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'style3' })}>
                <input type="checkbox" className="custom-control-input" id="estilo3" defaultChecked={styles?.style3} />
                <label className="custom-control-label" htmlFor="estilo3">Estilo 3</label>
            </div>

            <div className='mb-2'>
                <h6>Titulo</h6>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    defaultValue={styles?.titulo}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'titulo' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Subtitulo</h6>
                <input
                    defaultValue={styles?.subTitulo}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'subTitulo' })}
                />
            </div>
            <div className='d-flex align-items-cente mb-2'>
                <h6 className='m-0'>Url Imagen</h6>
                <a onClick={() => modificarModal('urlImg')}>
                    <Image2 className="ml-1" set="bold" />
                </a>
            </div>
            <input
                defaultValue={urlImg}
                type="text"
                disabled
                className="form-control form-control-sm mb-2"
                onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg' })}
            />

            <div className='d-flex align-items-cente mb-2'>
                <h6 className='m-0'>Url Imagen 2</h6>
                <a onClick={() => modificarModal('urlImg2')}>
                    <Image2 className="ml-1" set="bold" />
                </a>
            </div>
            <input
                defaultValue={urlImg2}
                type="text"
                disabled
                className="form-control form-control-sm mb-2"
                onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg2' })}
            />

            <div className='d-flex align-items-cente mb-2'>
                <h6 className='m-0'>Url Imagen 3</h6>
                <a onClick={() => modificarModal('urlImg3')}>
                    <Image2 className="ml-1" set="bold" />
                </a>
            </div>
            <input
                defaultValue={urlImg3}
                type="text"
                disabled
                className="form-control form-control-sm mb-2"
                onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg3' })}
            />
            <div className='mb-2'>
                <h4>Boton</h4>
                <OpcionesBoton {...props} />
            </div>
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </>
    )
}

export default OpcionesCarousel